import { Grid } from '@mui/material'
import React, { FunctionComponent } from 'react'

import { SimpleContainerBox } from '../../../base/components/Container/SimpleBox'
import Breadcrumb from '../../../base/components/Template/Breadcrumb/Breadcrumb'
import { articuloRoutesMap } from '../articuloRoutes'
import ArticuloListado from './listado/ArticuloListado'

interface OwnProps {}

type Props = OwnProps

/**
 * Gestion o pagina principal para gestionar los articulo
 * @param props
 * @constructor
 */
const ArticuloGestion: FunctionComponent<Props> = (props) => {
  return (
    <SimpleContainerBox maxWidth={'xl'}>
      <Breadcrumb routeSegments={[articuloRoutesMap.gestion]} />

      <Grid container spacing={2}>
        <Grid size={12}>
          <ArticuloListado />
        </Grid>
      </Grid>
    </SimpleContainerBox>
  )
}

export default ArticuloGestion
